<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div #studentHeader style="padding:10px;">
        <student-header [pageTitle]="'Attendance'" [showYearSelector]="true"></student-header>
    </div>
    <div class="flex-content">
        <div #tabs style="position: relative;" class="print-ignore">
            <tabs *ngIf="tabNames && tabNames.length > 0" [tabNames]="tabNames" [setIndex]="setIndex"
                (selectionsChange)="selections = $event" (selectionsChangeIndex)="selectionChange($event)"></tabs>

            <div style="display:inline-block;position: absolute;top:0;right:0;" *ngIf="!V10">
                <table>
                    <tr>
                        <td style="padding-right:10px;" translate>Days</td>
                        <td style="text-align:right;padding-right:10px;">
                            <span>{{(attendanceDaysAndHoursInfo.PossibleDays -
                                attendanceDaysAndHoursInfo.AbsenceDays)|number:'2.2-2'}}</span><span translate
                                style="padding-left: 3px">of</span>
                        </td>
                        <td style="text-align:right;">
                            <span>{{attendanceDaysAndHoursInfo.PossibleDays|number:'2.2-2'}}</span><span
                                style="padding-left:5px;">(</span>
                        </td>
                        <td style="text-align:right;">{{(((attendanceDaysAndHoursInfo.PossibleDays -
                            attendanceDaysAndHoursInfo.AbsenceDays)/(attendanceDaysAndHoursInfo.PossibleDays > 0 ?
                            attendanceDaysAndHoursInfo.PossibleDays : 1))*100)|number:'2.2-2'}}%)</td>
                    </tr>
                    <tr>
                        <td style="padding-right:10px;" translate>Hours</td>
                        <td style="text-align:right;padding-right:10px;">
                            <span>{{((attendanceDaysAndHoursInfo.PossibleMinutes -
                                attendanceDaysAndHoursInfo.AbsenceMinutes)/60)|number:'2.2-2'}}</span><span translate
                                style="padding-left: 3px">of</span>
                        </td>
                        <td style="text-align:right;">
                            <span>{{attendanceDaysAndHoursInfo.PossibleMinutes/60|number:'2.2-2'}}</span><span
                                style="padding-left:5px;">(</span>
                        </td>
                        <td style="text-align:right;">{{(((attendanceDaysAndHoursInfo.PossibleMinutes -
                            attendanceDaysAndHoursInfo.AbsenceMinutes)/(attendanceDaysAndHoursInfo.PossibleMinutes > 0
                            ? attendanceDaysAndHoursInfo.PossibleMinutes : 1))*100)|number:'2.2-2'}}%)</td>
                    </tr>
                </table>
            </div>
        </div>

        <div *ngIf="!viewDailyAttendance">
            <div *ngIf="selectionIndex == 0">
                <div #dropdown class="print-ignore">
                    <tyl-form-field label="" style="width: 250px;">
                        <mat-select [(value)]="selected" (selectionChange)="getStudentAttendanceInfo()"
                            id="dropdownSelect" aria-label="Select item to search by">
                            <mat-option *ngIf = "isStudentTeamExists" value="By Team"><span translate>By Teams</span></mat-option>
                            <mat-option value="By Date"><span translate>By Date (Entire Year)</span></mat-option>
                            <mat-option value="1"><span translate>By Student Schedule (Today Only)</span></mat-option>
                            <mat-option value="2"><span translate>By Student Schedule (This Term)</span></mat-option>
                            <mat-option value="3"><span translate>By Student Schedule (All)</span></mat-option>
                        </mat-select>
                    </tyl-form-field>
                </div>
                <div [hidden]="selected !='By Date' || selected == 'By Team'" style="height: 100%">
                    <div style="text-align:center;" *ngIf="attendance && attendance.length == 0">
                        <span translate>No absences or tardies exist for the student.</span>
                    </div>
                    <div *ngIf="attendance && attendance.length != 0">
                        <by-date-table #byDateTable [attendance]="attendance" [calendarUseAttendanceTypes]="calendarUseAttendanceTypes"></by-date-table>
                    </div>
                </div>

                <div [hidden]="selected =='By Date' || selected == 'By Team'" style="height: 100%">
                    <div style="text-align:center;" *ngIf="courseSchedules && courseSchedules.length == 0" translate>
                        <span translate>No absences or tardies exist for the student.</span>
                    </div>
                    <div *ngIf="courseSchedules && courseSchedules.length != 0">
                        <by-schedule-table #byScheduleTable [courseSchedules]="courseSchedules" [calendarUseAttendanceTypes]="calendarUseAttendanceTypes"></by-schedule-table>
                    </div>
                </div>

                <div [hidden]="selected != 'By Team'" style="height: 100%">
                    <div style="text-align:center;" *ngIf="studentTeamAttendance.length == 0" translate>
                        <span translate>No absences or tardies exist for the student.</span>
                    </div>
                    <div *ngIf="studentTeamAttendance && studentTeamAttendance.length != 0">
                        <by-team-table #byTeamTable [teamAttendance]="studentTeamAttendance"></by-team-table>
                    </div>
                </div>
            </div>

            <div *ngIf="selectionIndex == 1">
                <app-by-view-excessive #byViewExcessive
                    (selectedExcessiveAttendanceOptionValueChange)="selectedExcessiveAttendanceChange($event)">
                </app-by-view-excessive>
            </div>

            <div *ngIf="selectionIndex == 2">
                <by-special-additional #bySpecialAddition></by-special-additional>
            </div>
        </div>

        <div *ngIf="viewDailyAttendance">
            <app-daily-attendance></app-daily-attendance>
        </div>
    </div>
</tyl-kendo-pdf-export>
<div #footer class="flex-footer">
    <div class="flex-footer-left">
        <tyl-button *ngIf="selectionIndex == 0 || (selectionIndex == 1 && selectedExcessiveAttendanceOption==1)"
            image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"></tyl-button>
        <tyl-button *ngIf="selectionIndex == 0 || (selectionIndex == 1 && selectedExcessiveAttendanceOption==1) "
            image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>
        <tyl-button id="btnCodeLegend" image="Code Legend.png" label="Legend" (clickEvent)="CodeLegendClick()"
            *ngIf="selectionIndex != 1"></tyl-button>

        <tyl-button image="courses selected.png" label="Class Attendance" (clickEvent)="toggleView()"
            *ngIf="viewDailyAttendance && dailyAttendanceEnabled"></tyl-button>
        <tyl-button image="Calendar-One-On.png" label="Daily Attendance" (clickEvent)="toggleView()"
            *ngIf="!viewDailyAttendance && dailyAttendanceEnabled"></tyl-button>
        <tyl-button image="calendar text.png" label="Check History" (click)="viewHistoryClick()"
            *ngIf="!V10"></tyl-button>
        <tyl-button image="calendar text.png" label="View Self Check History" (click)="viewSelfCheckHistoryClick()"
            *ngIf="!V10 && showSelfCheckButton"></tyl-button>
        <tyl-button image="calendar text.png" label="Absent Notices" (click)="viewAbsentNoticeClick()"
            *ngIf="!V10 && showAbsentNoticeButton"></tyl-button>

    </div>
    <div class="flex-footer-middle" style="display: flex;align-items: center;">
        <!-- <filter-notification [filtered]="excessiveAttendanceAngularMatData.isFiltered()"
        (clearFilter)="clearFilterEvent.emit(); changeDetector.detectChanges();"></filter-notification> -->
        <filter-notification [filtered]="isFiltered()" (clearFilter)="clearFilter(); changeDetector.detectChanges();">
        </filter-notification>
        <mat-checkbox id="checkboxShowAllCodes" [(ngModel)]="showAllCodes" (change)="getStudentAttendanceInfo()"
            *ngIf="(!V10 && selectionIndex == 0)">
            <span translate>Show codes that do not count as absences/tardies on the report card</span>
        </mat-checkbox>
    </div>
    <div class="flex-footer-right">
    </div>
</div>
